function n(n,o,t,f){n._m(o),n.o(o,"Button",()=>n.f(i)),n.o(o,"MainButton",()=>n.f(u));var i=n.i(t("44854410")),u=n.i(t("7f416d53"));}